
namespace RioERP.Products {
    export class ProductTeacherShareColumns {
        static columnsKey = 'Products.ProductTeacherShare';
    }
}